import React, { useEffect, useState } from 'react';
import { Table, Tag, Card, Button, Drawer, Form, Input, Upload, Select, DatePicker, Space, message, Switch } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { UserService } from '../../../Services/Manage/UserService';
import { LetterService } from '../../../Services/Manage/LetterService';
import useMessage from 'antd/es/message/useMessage';
import { ENDPOINT } from '../../../Services/ENDPOINT';
import { Image } from 'antd';

const normalizeUrl = (base, path) => {
    if (!path) return null;
    if (path.startsWith("http")) return path;
    return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
};


const LetterHeader = () => {
    const [data, setData] = useState([]);

    const [drawerVisible, setDrawerVisible] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [form] = Form.useForm();
    const [message, messageContxt] = useMessage();
    const [uploadList, setUploadList] = useState([]);


    const statusColors = {
        'Inactive': 'default',
        'Active': 'green',
    };

    const getAllLetterhead = async () => {
        try {
            const request = await LetterService.getAllHead();
            if (request.data && Array.isArray(request.data)) {
                const mappedData = request.data.map((item, index) => ({
                    ...item,
                    si_no: index + 1,
                    image_url: normalizeUrl(ENDPOINT.base, item.image_url),
                }));
                setData(mappedData);
            }
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        getAllLetterhead();
    }, [])

    const columns = [
        {
            title: 'S. No.',
            dataIndex: 'si_no',
            key: 'si_no',
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Image',
            dataIndex: 'image_url',
            key: 'image_url',
            render: (url) => {
                if (!url) return 'No Image';
                const fullUrl = normalizeUrl(ENDPOINT.base, url);
                return (
                    <img
                        src={fullUrl}
                        alt="Letter Header"
                        style={{
                            width: 100,
                            height: 100,
                            objectFit: 'cover',
                            borderRadius: 6,
                            border: '1px solid #ddd',
                        }}
                        onError={(e) => {
                            e.target.onerror = null;
                            // e.target.src = 'https://via.placeholder.com/100?text=No+Image';
                        }}
                    />
                );
            },
        },

        {
            title: 'Tag',
            dataIndex: 'tag',
            key: 'tag',
            render: (tag) => <Tag style={{ fontSize: '16px', padding: '6px 12px' }} color="blue">{tag}</Tag>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <Tag
                    style={{ fontSize: '16px', padding: '6px 12px' }}
                    color={statusColors[status] || 'default'}
                >
                    {status ? status.toUpperCase() : 'N/A'}
                </Tag>
            ),
        },

        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            render: (text, record) => (
                <Space size="middle">
                    <Button
                        size='large'
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                    />
                    <Button
                        size='large'
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record)}
                    />
                </Space>
            ),
        },
    ];

 const showDrawer = () => {
    setEditingItem(null);
    form.resetFields();
    setUploadList([]); 
    setDrawerVisible(true);
};

    const handleEdit = async (record) => {
        setEditingItem(record);

        const imageFileList = record.image_url
            ? [{
                uid: "-1",
                name: record.title || "Uploaded Image",
                status: "done",
                url: record.image_url.startsWith("http")
                    ? record.image_url
                    : normalizeUrl(ENDPOINT.base, record.image_url),
            }]
            : [];

        form.setFieldsValue({
            ...record,
            status: record.status === "Active",
            image_url: imageFileList,
        });

        setUploadList(imageFileList); 
        setDrawerVisible(true);
    };


    const handleDelete = async (record) => {
        try {
            const request = await LetterService.deleteHead(record.id);
            if (request.status) {
                message.success(request.message);
                getAllLetterhead();
            } else {
                message.error(request.message);
            }
        } catch (error) {
            console.log(error);
            message.warning(error);
        }
    };

const handleDrawerClose = () => {
    setDrawerVisible(false);
    form.resetFields();
    setUploadList([]); 
};

    const onFinish = async (values) => {
        const user = await UserService.getOmeUser();

        let imageUrl = null;

      
        if (values.image_url && values.image_url.length > 0) {
            const file = values.image_url[0];

            if (file.response?.image?.path) {
     
                imageUrl = file.response.image.path;
            } else if (file.url && file.url.includes("/uploads/")) {
         
                imageUrl = file.url.replace(`${ENDPOINT.base}/`, "");
            } else {
                imageUrl = null; 
            }

        }

        const newItem = {
            ...values,
            added_by: user.uid,
            status: values.status ? "Active" : "Inactive",
            image_url: imageUrl,
        };

        try {
            if (editingItem) {
                const request = await LetterService.updateHead(newItem, editingItem.id);
                if (request.status) {
                    message.success(request.message);
                    getAllLetterhead();
                } else {
                    message.error(request.message);
                }
            } else {
                const request = await LetterService.createHead(newItem);
                if (request.status) {
                    message.success(request.message);
                    getAllLetterhead();
                } else {
                    message.error(request.message);
                }
            }
        } catch (err) {
            message.error(err.message);
        } finally {
            setDrawerVisible(false);
            form.resetFields();
        }
    };

    return (
        <div>
            <Card
                title="Headers"
                extra={
                    <Button
                        type="primary"
                        size='large'
                        icon={<PlusOutlined />}
                        onClick={showDrawer}
                    >
                        Add Header
                    </Button>
                }
            >
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: true }}
                />
            </Card>
            {messageContxt}
            <Drawer
                title={editingItem ? "Edit Header" : "Add New Header"}
                width={500}
                onClose={handleDrawerClose}
                visible={drawerVisible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="title"
                        label="Title"
                    >
                        <Input size='large' placeholder='Add header title for reference' />
                    </Form.Item>

                    <Form.Item
                        name="image_url"
                        label="Image"
                        valuePropName="fileList"
                        getValueFromEvent={e => Array.isArray(e) ? e : e?.fileList}
                    >
                        <Upload
                            listType="picture-card"
                            maxCount={1}
                            fileList={uploadList}
                            onChange={({ fileList }) => {
                                setUploadList(fileList);
                                form.setFieldsValue({ image_url: fileList });
                            }}
                            customRequest={async ({ file, onSuccess, onError }) => {
                                const formData = new FormData();
                                formData.append("image", file);

                                try {
                                    const res = await fetch(`${ENDPOINT.Head}/upload-image`, {
                                        method: "POST",
                                        body: formData,
                                    });
                                    const result = await res.json();

                                    if (result.status && result.success) {
                                        const fullUrl = normalizeUrl(ENDPOINT.base, result.image.path);
                                        const newFile = {
                                            uid: file.uid,
                                            name: file.name,
                                            status: "done",
                                            url: fullUrl,
                                            response: result,
                                        };
                                        setUploadList([newFile]);
                                        form.setFieldsValue({ image_url: [newFile] });
                                        onSuccess(result, file);
                                        message.success("Upload successful!");
                                    } else throw new Error(result.message || "Upload failed");
                                } catch (err) {
                                    onError(err);
                                    message.error("Upload failed: " + err.message);
                                }
                            }}
                            onRemove={() => {
                                setUploadList([]);
                                form.setFieldsValue({ image_url: [] });
                            }}
                            accept="image/jpeg,image/jpg,image/png,image/webp"
                        >
                            {uploadList.length === 0 && (
                                <div>
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </div>
                            )}
                        </Upload>

                    </Form.Item>
                    <Form.Item
                        name="tag"
                        label="Tag"
                    >
                        <Select size="large" placeholder="Select title type">
                            <Select.Option value="header">Header</Select.Option>
                            <Select.Option value="footer">Footer</Select.Option>
                            <Select.Option value="watermark">Watermark</Select.Option>
                        </Select>
                        
                    </Form.Item>

                    <Form.Item
                        name="status"
                        label="Status"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren="Active"
                            unCheckedChildren="Inactive"
                            style={{ transform: "scale(1.3)", marginLeft: "15px", marginTop: "4px" }}
                        />
                    </Form.Item>


                    <Form.Item>
                        <div style={{ textAlign: 'right', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <Button size='large' type="primary" htmlType="submit">
                                {editingItem ? 'Update' : 'Add'}
                            </Button>
                            <Button size='large' onClick={handleDrawerClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Drawer>
        </div>
    );
};

export default LetterHeader;